import React from "react";
import { fireEvent, render, screen, waitFor } from "@testing-library/react";
import "@testing-library/jest-dom";
import { useChatStore } from "@metalmind-ab/mmagent-chat-ui";
import { ChatPanel } from "./ChatPanel";

jest.mock("@metalmind-ab/mmagent-chat-ui/styles.css", () => ({}), {
  virtual: true,
});
jest.mock("../../../../../hooks/useAuthHeaders", () => ({
  useAuthHeaders: () => async () => ({}),
}));
jest.mock("../../../../../config/runtimeConfig", () => ({
  getApiBaseUrl: () => "http://localhost",
}));
jest.mock("../../../../../utils/chatResumeOptions", () => ({
  buildChatResumeOptions: () => ({}),
}));

beforeEach(() => {
  useChatStore.getState().clearMessages();
  useChatStore.getState().setLoading(false);
  useChatStore.getState().setConversationId(null);
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
});

it("keeps a Meridian stream open until the panel unmounts", async () => {
  let started = false;
  let aborted = false;
  const originalFetch = global.fetch;
  const consoleError = jest
    .spyOn(console, "error")
    .mockImplementation((message) => {
      if (String(message).includes("Maximum update depth exceeded")) {
        throw new Error("Maximum update depth exceeded");
      }
    });
  global.fetch = jest.fn(async (_url, init) => {
    if (init?.method === "POST") {
      started = true;
      init.signal?.addEventListener("abort", () => {
        aborted = true;
      });
      return {
        ok: true,
        status: 200,
        headers: { get: () => null },
        body: { getReader: () => ({ read: () => new Promise(() => {}) }) },
      } as unknown as Response;
    }
    return {
      ok: true,
      status: 200,
      json: async () => ({ items: [], total: 0 }),
    } as Response;
  });
  try {
    const { unmount } = render(
      <ChatPanel
        workspaceId="workspace-1"
        documentTypeId={7}
        documentTypeName="Template"
        onSectionsChanged={() => {}}
        onClose={() => {}}
      />,
    );
    const input = await screen.findByPlaceholderText("Ask about sections...");
    fireEvent.change(input, { target: { value: "hello" } });
    fireEvent.keyDown(input, { key: "Enter" });
    await waitFor(() => expect(started).toBe(true));
    expect(
      await screen.findByPlaceholderText("Ask about sections..."),
    ).toBeInTheDocument();
    expect(aborted).toBe(false);
    unmount();
    await waitFor(() => expect(aborted).toBe(true));
  } finally {
    global.fetch = originalFetch;
    consoleError.mockRestore();
  }
});
